import { useNavigate } from 'react-router-dom'
import { useAuthStore } from '../../stores/authStore'
import './auth.css'

interface UserMenuProps {
  onNavigate?: (page: 'dashboard' | 'history' | 'settings') => void
}

export function UserMenu({ onNavigate }: UserMenuProps) {
  const { user, profile, signOut } = useAuthStore()
  const navigate = useNavigate()

  if (!user) return null

  const initials = profile?.full_name
    ? profile.full_name.split(' ').map(n => n[0]).join('').toUpperCase()
    : user.email?.[0].toUpperCase() || '?'

  const handleNav = (page: string) => {
    if (page === 'dashboard') navigate('/')
    else if (page === 'settings') navigate('/settings')
    else if (page === 'history') navigate('/exports')
    onNavigate?.(page as 'dashboard' | 'history' | 'settings')
  }

  return (
    <div className="user-menu">
      <div className="user-avatar">
        {profile?.avatar_url ? (
          <img src={profile.avatar_url} alt={profile.full_name || 'User'} />
        ) : (
          initials
        )}
      </div>

      <div className="user-dropdown">
        <div className="user-info">
          <div className="user-name">{profile?.full_name || 'User'}</div>
          <div className="user-email">{user.email}</div>
        </div>

        <button className="dropdown-item" onClick={() => handleNav('dashboard')}>
          <span>Dashboard</span>
        </button>
        <button className="dropdown-item" onClick={() => handleNav('history')}>
          <span>Build History</span>
        </button>
        <button className="dropdown-item" onClick={() => handleNav('settings')}>
          <span>Settings</span>
        </button>
        <button className="dropdown-item danger" onClick={signOut}>
          <span>Sign Out</span>
        </button>
      </div>
    </div>
  )
}
